import React from 'react';
import styled from 'styled-components';
import { color, space, border } from 'styled-system';
import { themeGet } from '@styled-system/theme-get';

const Wrapper = styled.div`
  ${color}
  ${space}

  display: flex;
  position: relative;
  height: 8px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;

  :after {
    content: ' ';
    position: absolute;
    top: 0px;
    background-color: ${({ colorLine }) => themeGet(`colors.${colorLine}`)};
    height: 8px;
    width: ${({ percent }) => percent}%;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;

    ${border}
  }
`;

export default function line({ className, percent, defaultColor }) {
  return (
    <Wrapper className={className} bg="primary_100" colorLine={defaultColor} percent={percent} />
  );
}
